import axios from "axios"

async function getInvoicesAll() {
    return axios({
        method: "GET",
        url: `/api/v1/invoices`,
    })
}

async function getInvoicesAllByWorkspace(uuid:string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${uuid}/invoices`,
    })
}

async function getInvoicesByPaginate(uuid:string, data:any) {

    function query() {
        const {page, limit} = data;
        if (!data.page && !data.limit) return "";
        let query = "?";
        if (page) query = query + "page=" + page + "&";
        if (limit) query = query + "limit=" + limit + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${uuid}/invoices-paginate${query()}`,
    })
}

async function getInvoicesAllByPaginate(data:any) {

    function query() {
        const {page, limit} = data;
        if (!data.page && !data.limit) return "";
        let query = "?";
        if (page) query = query + "page=" + page + "&";
        if (limit) query = query + "limit=" + limit + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/invoices-paginate${query()}`,
    })
}

async function getInvoiceDetails(uuid: string, invoiceUuid: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${uuid}/invoices/${invoiceUuid}`
    })
}

async function getInvoiceDetailsByAdmin(invoiceUuid: string) {
    return axios({
        method: "GET",
        url: `/api/v1/invoices/${invoiceUuid}`
    })
}

async function getInvoicesAllFilterMonth(data: any) {
    function query() {
        const {start_date, end_date } = data;
        if (!data.start_date && !data.end_date) return "";
        let query = "?";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/invoices-date-search${query()}`
    })
}

async function getInvoicesFilterMonth(data: any) {
    function query() {
        const {start_date, end_date } = data;
        if (!data.start_date && !data.end_date) return "";
        let query = "?";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${data.uuid}/invoices-date-search${query()}`
    })
}


async function getPaymentUrl(uuid: string, invoiceId: string) {
    return axios({
        method: "POST",
        url: `/api/v1/workspaces/${uuid}/invoices/${invoiceId}/payments`,

    })
}

export {
    getInvoicesAll,
    getInvoicesAllByWorkspace,
    getInvoiceDetails,
    getInvoiceDetailsByAdmin,
    getInvoicesAllFilterMonth,
    getInvoicesFilterMonth,
    getPaymentUrl,
    getInvoicesByPaginate,
    getInvoicesAllByPaginate
}